module.exports = __webpack_public_path__ + "img/user-bg.620bdc73.png";